import Styles from './InstagramStoryLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const InstagramStoryLoadingPreview = () => {
  return (
    <div className={Styles.instagramStoryLoadingPreview}>
      <div className={Styles.header}>
        <div className={Styles.storyLine} />
        <div className={Styles.storyLineLoaded} />
        <div className={Styles.row}>
          <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 98 }} title={false} />
          <div className={Styles.second}>
            <Skeleton avatar={false} active paragraph={{ rows: 1, width: 12 }} title={false} />
          </div>
        </div>
      </div>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <Skeleton avatar={false} active paragraph={{ rows: 1, width: 241 }} title={false} />
        <Skeleton avatar={{ size: 33 }} active title={false} paragraph={false} />
        <Skeleton avatar={{ size: 33 }} active title={false} paragraph={false} />
      </div>
    </div>
  )
}
